import React, { PropsWithChildren } from "react";

import { Button } from "@components/General/Button/button.component";
import { useCallToActionContext } from "@components/General/CallToAction/callToAction.context";
import { AdvisorType } from "@components/General/CallToAction/types/enums/advisorType.enum";

type AdvisorButtonProps = PropsWithChildren<{
    advisorId: string;
    advisorType: AdvisorType;
}>;

const AdvisorButton = ({
    advisorId,
    advisorType,
    children,
}: AdvisorButtonProps) => {
    const { trackingProperties, styleProperties } = useCallToActionContext();

    return (
        <Button
            {...styleProperties.button}
            type="button"
            dataAttributes={{
                ...trackingProperties.click,
                ...(advisorType === AdvisorType.ProductCheck && {
                    "data-product-check": "",
                }),
                "data-advisor-id": advisorId,
                "data-aiden-mode": "sidebar",
            }}
            stopPropagation={false}
        >
            {children}
        </Button>
    );
};

export { AdvisorButton };
